'use client'

import { createContext, type PropsWithChildren, use } from 'react'

export interface MarketRoute {
  loanSymbol: string
  collateralSymbol: string | null
}

const MarketRouteContext = createContext<MarketRoute | null>(null)

/** The symbols the market layout resolved, for the hero skeletons (`loading.tsx` gets no params). */
export const MarketRouteProvider = ({
  loanSymbol,
  collateralSymbol,
  children
}: PropsWithChildren<MarketRoute>) => {
  const value = { loanSymbol, collateralSymbol }
  return <MarketRouteContext value={value}>{children}</MarketRouteContext>
}

export const useMarketRoute = () => {
  return use(MarketRouteContext)
}
